import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { Link, useHistory } from 'react-router-dom';
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  Divider,
  Menu,
  MenuItem,
  Button,
} from '@material-ui/core';

import ListItemLink from '../ListItemLink';
import { ConnectButton } from "@rainbow-me/rainbowkit"; // Import RainbowKit's ConnectButton

import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AccountButton from './AccountButton';
import styled from 'styled-components';

import hoglogo from '../../assets/img/logo.webp';
import ThemeButton from '../ThemeModal/ThemeButton';
import TokenSymbol from './../TokenSymbol/TokenSymbol';
import useTombFinance from '../../hooks/useTombFinance';
import useTombStats from '../../hooks/useTombStats';
import Card from '../CardPyramid';
import CardContent from '../CardContent';
import Container from '../Container';
import { FaWallet } from 'react-icons/fa'; // or any other icon you prefer
import { useDisconnect } from 'wagmi';
import ShimmerLoader from '../ShimmerLoader';

export const CButton = () => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const { disconnect } = useDisconnect();

  const handlePortfolioClick = () => {
    setShowModal(false);
    history.push('/portfolio');
  };

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <div className="relative z-0">
                    <a
                      className="relative inline-block group cursor-pointer"
                      onClick={openConnectModal}
                    >
                      <div className="absolute inset-0 bg-gradient-sonic-mirrored animate-gradient rounded-full blur-sm group-hover:blur group-hover:brightness-125 transition"></div>
                      <div className="relative z-10 p-[1px] rounded-full bg-gradient-sonic-mirrored animate-gradient">
                        <div className="flex items-center justify-center gap-x-2 px-3 py-1 bg-black/85 rounded-full group-hover:bg-black/75 transition">
                          <span className="text-white/85 font-medium text-body-sm group-hover:text-white transition">
                            Connect Wallet
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              }

              if (chain.unsupported) {
                return (
                  <div className="relative z-40">
                    <a
                      className="relative inline-block group cursor-pointer"
                      onClick={openChainModal}
                    >
                      <div className="absolute inset-0 bg-gradient-sonic-mirrored animate-gradient rounded-full blur-sm group-hover:blur group-hover:brightness-125 transition"></div>
                      <div className="relative z-10 p-[1px] rounded-full bg-gradient-sonic-mirrored animate-gradient">
                        <div className="flex items-center justify-center gap-x-2 px-3 py-1 bg-black/85 rounded-full group-hover:bg-black/75 transition">
                          <span className="text-white/85 font-medium text-body-sm group-hover:text-white transition">
                            Wrong Network
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              }

              return (
                <div className="relative z-40">
                  <div className="flex flex-col space-y-2">
                    <a
                      className="relative inline-block group cursor-pointer"
                      onClick={() => setShowModal(true)}
                    >
                      <div className="absolute inset-0 bg-gradient-sonic-mirrored animate-gradient rounded-full blur-sm group-hover:blur group-hover:brightness-125 transition"></div>
                      <div className="relative z-10 p-[1px] rounded-full bg-gradient-sonic-mirrored animate-gradient">
                        <div className="flex items-center justify-center gap-x-2 px-3 py-1 bg-black/85 rounded-full group-hover:bg-black/75 transition">
                          <span className="text-white/85 font-medium text-body-sm group-hover:text-white transition">
                            {account.displayName}
                            {account.displayBalance
                              ? ` (${account.displayBalance})`
                              : ""}
                          </span>
                        </div>
                      </div>
                    </a>

                    {/* Custom Modal */}
                    {showModal && (
                      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
                        <Container size="sm">
                          <Card>
                            <CardContent>
                              <div className="p-6 relative min-w-[320px]">
                                <button
                                  className="absolute top-2 right-2 text-white/70 hover:text-white transition"
                                  onClick={() => setShowModal(false)}
                                >
                                  ✕
                                </button>
                                
                                {/* Header with Icon */}
                                <div className="flex items-center gap-3 mb-6">
                                  <div className="p-2 bg-gradient-sonic-mirrored rounded-full">
                                    <FaWallet size={24} className="text-white" />
                                  </div>
                                  <div>
                                    <h2 className="text-white text-xl font-semibold">Account</h2>
                                    <div className="text-white/70 text-sm break-all mt-1">
                                      {account.address}
                                    </div>
                                  </div>
                                </div>

                                {/* Buttons in a row */}
                                <div className="grid grid-cols-2 gap-2">
                                  {/* Portfolio Button 
                                  <button
                                    className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-2 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body'
                                    onClick={handlePortfolioClick}
                                  >
                                    Portfolio
                                  </button>
*/}
                                  {/* Copy Address Button */}
                                  <button
                                    className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-2 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body'
                                    onClick={() => {
                                      navigator.clipboard.writeText(account.address);
                                      setShowModal(false);
                                    }}
                                  >
                                    Copy
                                  </button>

                                  {/* Disconnect Button */}
                                  <button
                                    className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-2 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-[#BD6EAC66] hover:bg-[rgba(193,82,169,0.53)] transition focus-visible:ring-button text-body'
                                    onClick={() => {
                                      disconnect();
                                      setShowModal(false);
                                    }}
                                  >
                                    Disconnect
                                  </button>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        </Container>
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

const Nav2 = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [showAidensGardenModal, setShowAidensGardenModal] = useState(false);
  const history = useHistory();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElSbonds, setAnchorElSbonds] = React.useState(null);

  const handleClickSbonds = (e: any) => {
    setAnchorElSbonds(e.currentTarget);
  };

  const handleCloseSbonds = () => {
    setAnchorElSbonds(null);
  };

  const [anchorElGames, setAnchorElGames] = React.useState(null);

  const handleClickGames = (e: any) => {
    setAnchorElGames(e.currentTarget);
  };

  const handleCloseGames = () => {
    setAnchorElGames(null);
  };

  const [anchorElStaking, setAnchorElStaking] = React.useState(null);

  const handleClickStaking = (e: any) => {
    setAnchorElStaking(e.currentTarget);
  };

  const handleCloseStaking = () => {
    setAnchorElStaking(null);
  };

  const [anchorElSwappers, setAnchorElSwappers] = React.useState(null);

  const handleClickSwappers = (e: any) => {
    setAnchorElSwappers(e.currentTarget);
  };

  const handleCloseSwappers = () => {
    setAnchorElSwappers(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const [sonicPrice, setSonicPrice] = React.useState("-.--");
  const tombFinance = useTombFinance();
  const tombStats = useTombStats();

  const tombPriceInDollars = useMemo(
    () => (tombStats ? Number(tombStats.priceInDollars).toFixed(2) : "-.--"),
    [tombStats],
  );

  useEffect(() => {
    const fetchSonicPrice = async () => {
      const price = await tombFinance.getOSPairPrice();
      setSonicPrice(Number(price).toFixed(2));
    };
    fetchSonicPrice();
  }, [tombFinance]);

  const handleSanctumClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
    // Navigate directly to Sanctum V3
    history.push('/sanctumv3');
  };

  const handleAidensGardenClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
    setShowAidensGardenModal(true);
  };



  const navigateToAidensGarden = (version: string) => {
    setShowAidensGardenModal(false);
    if (version === 'hog') {
      history.push('/aidensgarden');
    } else {
      history.push('/aidensgardenghog');
    }
  };

  return (
    <div className={`relative z-10`}>
      <nav className="theme-dark bg-background text-foreground w-full">
        <div className="container mx-auto flex items-center justify-between h-16">
          <a className="flex items-center py-4" href="/">
            <div className="relative w-32 h-8">
              <img
                alt="Hand of God Logo"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-contain"
                style={{ position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent' }}
                src={hoglogo}
                data-darkreader-inline-color=""
              />
            </div>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 text-foreground hover:text-primary"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-x-3">
            <nav
              aria-label="Main"
              className="relative flex max-w-max flex-1 items-center justify-center z-30"
            >
              <ul className="group flex flex-1 list-none items-center justify-center space-x-1">
                <li>
                  <a href="/elysium" className="group inline-flex h-10 w-max items-center justify-center text-foreground bg-background px-4 py-2 text-sm font-medium transition-colors hover:text-primary">
                    Elysium
                  </a>
                </li>
                <li>
                  <a href="#" onClick={handleSanctumClick} className="group inline-flex h-10 w-max items-center justify-center text-foreground bg-background px-4 py-2 text-sm font-medium transition-colors hover:text-primary">
                    Sanctum
                  </a>
                </li>
                <li>
                  <a href="/purgatory" className="group inline-flex h-10 w-max items-center justify-center text-foreground bg-background px-4 py-2 text-sm font-medium transition-colors hover:text-primary">
                    Purgatory
                  </a>
                </li>
                <li>
                  <a href="#" onClick={handleAidensGardenClick} className="group inline-flex h-10 w-max items-center justify-center text-foreground bg-background px-4 py-2 text-sm font-medium transition-colors hover:text-primary">
                    Aiden's Garden
                  </a>
                </li>
                 
              </ul>
            </nav>
            <button 
              className="relative group min-w-[120px] flex items-center justify-center" 
              type="button" 
            >
              <div className="relative overflow-hidden z-10 p-[1px] rounded-full w-full bg-gradient-sonic-subtle">
                <div className="flex items-center justify-center gap-x-2 bg-black/85 rounded-full group-hover:bg-black/75 transition p-1.5 px-4">
                  <span className="text-white/85 font-medium group-hover:text-white transition flex items-center gap-2">
                    {tombPriceInDollars === "-.--" ? (
                      <>
                        <ShimmerLoader width="w-12" height="h-6" />
                        <TokenSymbol size={20} symbol="HOG" />
                      </>
                    ) : (
                      <>
                        {tombPriceInDollars}
                        <TokenSymbol size={20} symbol="HOG" />
                      </>
                    )}
                  </span>
                </div>
                <div className="-skew-x-12 group pointer-events-none via-white/20 absolute inset-0 z-20">
                  <div 
                    className="w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
                    style={{opacity: 1, willChange: 'opacity', transform: 'translateX(100%)'}}
                  >
                  </div>
                </div>
              </div>
            </button>
            <button 
              className="relative group min-w-[120px] flex items-center justify-center" 
              type="button" 
            >
              <div className="relative overflow-hidden z-10 p-[1px] rounded-full w-full bg-gradient-sonic-subtle">
                <div className="flex items-center justify-center gap-x-2 bg-black/85 rounded-full group-hover:bg-black/75 transition p-1.5 px-4">
                  <span className="text-white/85 font-medium group-hover:text-white transition flex items-center gap-2">
                    {sonicPrice === "-.--" ? (
                      <>
                        <ShimmerLoader width="w-12" height="h-6" />
                        <TokenSymbol size={20} symbol="OS" />
                      </>
                    ) : (
                      <>
                        {sonicPrice}
                        <TokenSymbol size={20} symbol="OS" />
                      </>
                    )}
                  </span>
                </div>
                <div className="-skew-x-12 group pointer-events-none via-white/20 absolute inset-0 z-20">
                  <div 
                    className="w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
                    style={{opacity: 1, willChange: 'opacity', transform: 'translateX(100%)'}}
                  >
                  </div>
                </div>
              </div>
            </button>
            
            
            
            <div className="relative z-40 flex items-center gap-x-3">
              <CButton />
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="/elysium" className="block px-3 py-2 text-foreground hover:text-primary">
                Elysium
              </a>
              <a href="#" onClick={handleSanctumClick} className="block px-3 py-2 text-foreground hover:text-primary">
                Sanctum
              </a>
              <a href="/purgatory" className="block px-3 py-2 text-foreground hover:text-primary">
                Purgatory
              </a>
              <a href="#" onClick={handleAidensGardenClick} className="block px-3 py-2 text-foreground hover:text-primary">
                Aiden's Garden
              </a>
             
              <div className="px-3 py-4 flex flex-col gap-3">
                <div className="flex flex-col items-start gap-2 w-full">
                  <button 
                    className="relative group w-[140px] flex items-center justify-center" 
                    type="button"
                  >
                    <div className="relative overflow-hidden z-10 p-[1px] rounded-full w-full bg-gradient-sonic-subtle">
                      <div className="flex items-center justify-center gap-x-2 bg-black/85 rounded-full group-hover:bg-black/75 transition p-1.5 px-3">
                        <span className="text-white/85 font-medium group-hover:text-white transition flex items-center gap-2">
                          {tombPriceInDollars === "-.--" ? (
                            <>
                              <ShimmerLoader width="w-12" height="h-6" />
                              <TokenSymbol size={16} symbol="HOG" />
                            </>
                          ) : (
                            <>
                              {tombPriceInDollars}
                              <TokenSymbol size={16} symbol="HOG" />
                            </>
                          )}
                        </span>
                      </div>
                      <div className="-skew-x-12 group pointer-events-none via-white/20 absolute inset-0 z-20">
                        <div className="w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
                             style={{opacity: 1, willChange: 'opacity', transform: 'translateX(100%)'}}></div>
                      </div>
                    </div>
                  </button>
                  <button 
                    className="relative group w-[140px] flex items-center justify-center" 
                    type="button"
                  >
                    <div className="relative overflow-hidden z-10 p-[1px] rounded-full w-full bg-gradient-sonic-subtle">
                      <div className="flex items-center justify-center gap-x-2 bg-black/85 rounded-full group-hover:bg-black/75 transition p-1.5 px-3">
                        <span className="text-white/85 font-medium group-hover:text-white transition flex items-center gap-2">
                          {sonicPrice === "-.--" ? (
                            <>
                              <ShimmerLoader width="w-12" height="h-6" />
                              <TokenSymbol size={16} symbol="OS" />
                            </>
                          ) : (
                            <>
                              {sonicPrice}
                              <TokenSymbol size={16} symbol="OS" />
                            </>
                          )}
                        </span>
                      </div>
                      <div className="-skew-x-12 group pointer-events-none via-white/20 absolute inset-0 z-20">
                        <div className="w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
                             style={{opacity: 1, willChange: 'opacity', transform: 'translateX(100%)'}}></div>
                      </div>
                    </div>
                  </button>
                </div>
                <CButton />
              </div>
            </div>
          </div>
        )}
      </nav>



      {/* Aiden's Garden Pool Selection Modal */}
      {showAidensGardenModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
          <Container size="sm">
            <Card>
              <CardContent>
                <div className="p-6 relative min-w-[320px]">
                  <button
                    className="absolute top-2 right-2 text-white/70 hover:text-white transition"
                    onClick={() => setShowAidensGardenModal(false)}
                  >
                    ✕
                  </button>
                  
                  {/* Header */}
                  <div className="mb-6 text-center">
                    <h2 className="text-white text-xl font-semibold">Choose Aiden's Garden Pool</h2>
                    <p className="text-white/70 mt-2">Select which pool you want to deposit</p>
                  </div>

                  {/* Buttons */}
                  <div className="grid grid-cols-2 gap-4">
                    <button
                      className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-3 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body'
                      onClick={() => navigateToAidensGarden('hog')}
                    >
                      <div className="flex items-center gap-2">
                        <TokenSymbol symbol="HOG" size={20} />
                        <span>/</span>
                        <TokenSymbol symbol="OS" size={20} />
                      </div>
                    </button>
                    
                    <button
                      className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-3 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body'
                      onClick={() => navigateToAidensGarden('ghog')}
                    >
                      <div className="flex items-center gap-2">
                        <TokenSymbol symbol="GHOG" size={20} />
                        <span>/</span>
                        <TokenSymbol symbol="OS" size={20} />
                      </div>
                    </button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Container>
        </div>
      )}
    </div>
  );
};

export default Nav2;
